export default __webpack_public_path__ + "static/media/amanda-jones-oHVdj31R3F4-unsplash.f9e3a94e.jpg";